import { RouteConfig } from "vue-router";

export const REmployeeProfileDocumentsBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile-documents-browse" */
      "./VEmployeeProfileDocumentsBrowse.vue"
    ),
  meta: {
    title: "My Profile",
  },
};
